
import {bus} from '../bus'
class BaseModal {
    constructor (showClose,mes,duration) {
        this.showClose = showClose //私有属性关闭弹框
        this.mes = mes //私有属性消息
        this.duration = duration //私有属性时间
    }
}

class SucBaseModal extends BaseModal {
    constructor(showClose,mes,duration) {
        super(showClose,mes,duration)
    }
    showMsg () {
        return bus.$message.success({
            showClose: this.showClose,
            message: this.mes.toString(),
            duration: this.duration
        });
    }
    showNotifyMsg () {
        return bus.$notify({
            title: '成功',
            message: this.mes,
            type: 'success'
        });
    }
}

class ErrBaseModal extends BaseModal {
    constructor(showClose,mes,duration) {
        super(showClose,mes,duration)
    }
    showMsg () {
        return bus.$message.error({
            showClose: this.showClose,
            message: this.mes.toString(),
            duration: this.duration
        });
    }
    showNotifyMsg () {
        return bus.$notify.error({
            title: '错误',
            message: this.mes
        });
    }
}

// 顶部消息提示
const SuccesBase = (mes) => {
    return new SucBaseModal(true, mes, 2000).showMsg()
}
const ErrBase = (mes) => {
    return new ErrBaseModal(true, mes, 2000).showMsg()
}
// 右侧消息提示
const SuccesNotify = (mes) => {
    return new SucBaseModal(true, mes, 2000).showNotifyMsg()
}
const ErrNotify = (mes) => {
    return new ErrBaseModal(true, mes, 2000).showNotifyMsg()
}
const ApiRequest = (req) => {
    if (req.status !== "0" || !req.status) {
        ErrBase(req.message) 
        if (req.message === "用户未登录") {
            bus.$emit('goto', '/login')
            return false
        }
        return false
    } else {
        return true
    }
}
export {
    ApiRequest,
    SuccesBase,
    ErrBase,
    SuccesNotify,
    ErrNotify
}



// WEBPACK FOOTER //
// ./src/base/baseModel.js